import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { RecommendationsFormComponent } from '../customers/community/recommandations-form/recommandations-form.component';
import { LocalServiceService } from '../shareModule/services/local-service.service';
import { CommonService } from '../shareModule/services/common.service';
import { PopUpService } from '../popupservice.service';

@Component({
  selector: 'app-search-modal',
  templateUrl: './search-modal.component.html',
  styleUrl: './search-modal.component.scss',
})
export class SearchModalComponent {
  @Input()
  selectedFilterMap = [];

  @Output()
  viewProductDetails = new EventEmitter();

  public isSearchFromHomepage = false;
  public showMoreSubcats = false;
  public selectedTypesId = new Set<any>();
  public selectedSubCatIds = new Set();

  @Input()
  public set maps(value) {
    this._maps = value;
    this.cdr.detectChanges();
  }

  public get maps() {
    return this._maps;
  }
  public _maps: any = {
    search: '',
    postalCode: 'All',
    radius: 5,
    products: [],
    productsToCompare: [],
    all: true,
    subCategoriesBasedOnKeyWords: [],
    subcats: [],
    fetchedFaqs: [],
    filter: '',
  };

  public filterMaps: any = [
    {
      name: 'Affordable',
      value: 'affordable',
      icon: 'fa-solid fa-dollar-sign',
      selected: false,
    },
    {
      name: 'Available now',
      value: 'available',
      icon: 'fa-solid fa-clock',
      selected: false,
    },
    {
      name: 'Promotion',
      value: 'promotion',
      icon: 'fa-solid fa-bolt',
      selected: false,
    },
  ];

  constructor(
    public modal: NgbActiveModal,
    private local: LocalServiceService,
    private commonService: CommonService,
    private popup: PopUpService,
    private cdr: ChangeDetectorRef
  ) {}

  paramChange() {
    //console.log('params change', this.maps);
    this.selectedSubCatIds.clear();
    this.selectedTypesId.clear();
    this.maps = structuredClone(this.maps);
    this.maps.products.sort((a, b) => {
      const aGlow = a.glowPoints > 0 && a.glowType === 1 ? 1 : 0;
      const bGlow = b.glowPoints > 0 && b.glowType === 1 ? 1 : 0;
      return bGlow - aGlow;
    });
  }

  public viewProduct(productData) {
    this.viewProductDetails.next(productData);
  }

  public openRecommendationForm() {
    if (!this.local.getUser()) {
      this.commonService.clickButton('loginBtn');
      return;
    }
    // if (this.screenWidth <= 767) {
    //   this.bottomSheet.open(RecommendationsFormComponent, {
    //     panelClass: 'bottom-sheet-1',
    //   });
    // } else {
    //   this.modalService.open(RecommendationsFormComponent);
    // }
    this.popup.openPopup(RecommendationsFormComponent, {
      bottomSheetPanelClass: 'bottom-sheet-1',
    });
  }
}
